import Modal from 'bootstrap/js/dist/modal';

const newsletterModal = new Modal('#newsletter')
const newsletterBtns = document.querySelectorAll('a[href^="#newsletter"]');

if(newsletterBtns) {
  newsletterBtns.forEach((btn)=> {
    btn.addEventListener('click', (e)=> {
      e.preventDefault();
      console.log('yo');
      newsletterModal.show();
      return false;
    });
    
  })
}